import * as React from "react";

interface IChartLoader {
  chart: any;
  loader: any;
  data: any;
  loading: boolean;
  dataKey?: string;
  dateKey?: string;
  key1?: string;
  key2?: string;
  lineKey?: string;
  strokePrimary?: boolean;
  chartSyncId?: string;
}

const ChartLoader: React.SFC<IChartLoader> = (props) => {
  const ChartComponent = props.chart;
  const Loader = props.loader;
  if (props.loading) {
    return <Loader {...props} />;
  }
  return <ChartComponent {...props} />;
};

export default React.memo(ChartLoader);
